import * as Context from "effect/Context";
import * as Effect from "effect/Effect";
import * as FileSystem from "effect/FileSystem";
import * as Layer from "effect/Layer";
import * as Redacted from "effect/Redacted";
import path from "pathe";
import { rootDir } from "./Profile.js";
const credentialsDirPath = path.join(rootDir, "credentials");
export const profileCredentialsDirPath = (profile) => path.join(credentialsDirPath, profile);
export const credentialsFilePath = (profile, provider) => path.join(profileCredentialsDirPath(profile), `${provider}.json`);
export class CredentialsStore extends Context.Service()("Alchemy::CredentialsStore") {
}
export const CredentialsStoreLive = Layer.effect(CredentialsStore, Effect.gen(function* () {
    const fs = yield* FileSystem.FileSystem;
    const read = (profile, provider) => fs.readFileString(credentialsFilePath(profile, provider)).pipe(Effect.catch(() => Effect.succeed(undefined)), Effect.map((data) => {
        if (data === undefined)
            return undefined;
        try {
            return JSON.parse(data);
        }
        catch {
            return undefined;
        }
    }));
    const write = (profile, provider, credentials) => {
        const filePath = credentialsFilePath(profile, provider);
        return fs.makeDirectory(path.dirname(filePath), { recursive: true }).pipe(Effect.flatMap(() => {
            return fs.writeFileString(filePath, JSON.stringify(credentials, null, 2));
        }));
    };
    const remove_ = (profile, provider) => fs
        .remove(credentialsFilePath(profile, provider))
        .pipe(Effect.catch(() => Effect.void));
    const deleteProfile = (profile) => fs
        .remove(profileCredentialsDirPath(profile), { recursive: true })
        .pipe(Effect.catch(() => Effect.void));
    return {
        read,
        write,
        delete: remove_,
        deleteProfile,
    };
}));
export function displayRedacted(r, visibleChars = 4) {
    const raw = Redacted.value(r);
    if (raw.length <= visibleChars)
        return "****";
    return `${raw.slice(0, visibleChars)}****`;
}
//# sourceMappingURL=Credentials.js.map